<script lang="ts">
	import {
		DeviceRPi,
		ProjectorPowerListener,
		ProjectorPowerManager,
		type Device,
		type ProjectorPowerState,
	} from "luxedo-data"
	import PowerButton from "../../../../reusable/icons/PowerButton.svelte"
	import ProjectorResolutionInput from "./inputs/ProjectorResolutionInput.svelte"
	import ProjectorTimeoutInput from "./inputs/ProjectorTimeoutInput.svelte"
	import { ProjectorMenuController } from "../../ProjectorMenuController.svelte"
	import { Toast } from "toaster"

	let device: DeviceRPi = $derived(ProjectorMenuController.ctx.device as unknown as DeviceRPi)

	let powerStateListener = $derived(new ProjectorPowerListener(device))
	let projectorPower: ProjectorPowerState = $derived(powerStateListener.powerState)

	let isPowerChanging: boolean = $state(false)

	function onDeviceChange(device: DeviceRPi) {
		if (!device) return
		return ProjectorPowerManager.subscribeTo(device.id, onPowerStateUpdate)
	}

	function onPowerStateUpdate(ctx: { state: ProjectorPowerState; isChanging: boolean }) {
		const { state, isChanging } = ctx
		isPowerChanging = isChanging
	}

	async function toggleProjectorPower() {
		let newPower: "ON" | "OFF"
		if (projectorPower === "ON") {
			newPower = "OFF"
		} else {
			newPower = "ON"
		}

		try {
			Toast.text(`Powering projector ${newPower.toLowerCase()}`)
			await ProjectorPowerManager.setPower(device, newPower)
			Toast.success(`The projector has powered ${newPower.toLowerCase()}`)
		} catch (e) {
			console.error("Unable to modify projector power state.")
			Toast.error(`Unable to power ${newPower.toLowerCase()} the projector`)
		}
	}

	$effect(() => {
		return onDeviceChange(device)
	})
</script>

<div class="settings-block">
	<div class="flex-row projector-heading">
		<h2 class="setting-heading">Projector</h2>

		<PowerButton
			isOn={projectorPower === "ON"}
			togglePower={toggleProjectorPower}
			isChanging={isPowerChanging}
		/>
		<span class="power-control-info"
			>{ProjectorPowerManager.convertToReadableState(projectorPower)}</span
		>
	</div>
	<ProjectorResolutionInput />
	<ProjectorTimeoutInput />
</div>

<style>
	.setting-heading {
		margin-right: 0.25rem;
	}
</style>
